import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';

import img1 from "../images/gallery/img1.jpg";
import img1_1 from "../images/gallery/img1_1.png";

import img2 from "../images/gallery/img2.jpg";
import img2_1 from "../images/gallery/img2_1.png";

import img3 from "../images/gallery/img3.jpg";
import img3_1 from "../images/gallery/img3_1.png";

import img4 from "../images/gallery/img4.jpg";
import img4_1 from "../images/gallery/img4_1.png";


import img5 from "../images/gallery/img5.jpg";
import img5_1 from "../images/gallery/img5_1.png";

import img6 from "../images/gallery/img6.jpg";
import img6_1 from "../images/gallery/img6_1.png";

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper,
    padding: 5,
  },
  gridList: {
    width: "100%",
    height: 'auto',
    // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
    transform: 'translateZ(0)',
  },
}));



const tileData = [
  {
     img: img1,
     title: 'MESSI',
     author: 'MISABANITA',
     cols: 2,
   },
   {
     img: img1_1,
     title: 'MESSI',
     author: 'MISABANITA',
     cols: 2,
   },
   {
     img: img2,
     title: 'MOSCU',
     author: 'MISABANITA',
     cols: 2,
   },
   {
     img: img2_1,
     title: 'MOSCU',
     author: 'MISABANITA',
     cols: 2,
   },
   {
     img: img3,
     title: 'PARIS',
     author: 'MISABANITA',
     cols: 2,
   },
   {
     img: img3_1,
     title: 'PARIS',
     author: 'MISABANITA',
     cols: 2,
   },
   {
     img: img4,
     title: 'HAPPY TENAGER',
     author: 'MISABANITA',
     cols: 2,
   },
   {
     img: img4_1,
     title: 'HAPPY TENAGER',
     author: 'MISABANITA',
     cols: 2,
   },
   {
     img: img5,
     title: 'MACHU PICCHU',
     author: 'MISABANITA',
     cols: 2,
   },
   {
     img: img5_1,
     title: 'MACHU PICCHU',
     author: 'MISABANITA',
     cols: 2,
   },
   {
     img: img6,
     title: 'COLISEO ROMANO',
     author: 'MISABANITA',
     cols: 2,
   },
   {
     img: img6_1,
     title: 'COLISEO ROMANO',
     author: 'MISABANITA',
     cols: 2,
   },
];
 
export default function ImageGridList() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <GridList  cellHeight={200} className={classes.gridList} cols={8} >
        {tileData.map((tile) => (
          <GridListTile key={tile.img} cols={tile.cols || 1}>
            <img src={tile.img} alt={tile.title} />
          </GridListTile>
        ))}
      </GridList>
    </div>
  );
}
